/**
 * Dashboard Skeleton Loader
 * Displays a loading placeholder while the main dashboard loads
 * Improves perceived performance by showing UI structure immediately
 */

export function DashboardSkeleton() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 animate-pulse">
      {/* Menu Bar Skeleton */}
      <div className="h-7 bg-slate-900/50 border-b border-slate-800/50" />
      
      {/* Main Content */}
      <div className="relative">
        {/* Background placeholder */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/30 via-slate-800/20 to-slate-900/30" />
        
        {/* Today's Tasks Widget Skeleton - Top Right */}
        <div className="absolute top-16 right-6 w-80 h-96 bg-slate-800/30 backdrop-blur-sm rounded-xl border border-slate-700/30" />
        
        {/* Dock Skeleton - Bottom Center */}
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 px-3 py-2 bg-slate-900/50 backdrop-blur-xl rounded-2xl border border-slate-800/50">
          {/* Dock Items */}
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="w-14 h-14 bg-slate-700/30 rounded-xl"
            />
          ))}
        </div>
      </div>
      
      {/* Loading indicator */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
        <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Loading Operating System...</p>
      </div>
    </div>
  );
}
